import { Div, LinkButton } from "@hopper-ui/components";
import type { ComponentProps, ReactNode } from "react";
import { useShellTranslation } from "../../../i18n/i18next.ts";
import styles from "./SkipToMain.module.css";

interface SkipToMainProps extends ComponentProps<typeof LinkButton> {
    href: string;
    children?: ReactNode;
    className?: string;
}

// The router handles the href without a native fragment jump, so the next Tab would start from the link.
function focusTarget(href: string) {
    const target = document.getElementById(href.slice(1));

    target?.setAttribute("tabindex", "-1");
    target?.focus();
}

export function SkipToMain({ href, children, className }: SkipToMainProps) {
    const { t } = useShellTranslation();

    return (
        <Div backgroundColor="neutral" padding="inset-md" className={`${styles["skip-to-main-link"]} ${className}`}>
            <LinkButton href={href} onPress={() => focusTarget(href)}>
                {children ?? t("SkipToMain.label")}
            </LinkButton>
        </Div>
    );
}
